<template>
    <div class="container" v-title data-title="班级评价">
      <span class="a-duan"></span>
      <div class="card-wrap">
        <div class="card classroom-info">
          <span class="title-arrow"></span>
          <p class="title">课堂信息</p>
          <div class="info">
            <div class="info-item">
              <span class="label">班级名称：</span>
              <span class="content">{{evaluateDetail.className && evaluateDetail.className}}</span>
            </div>
            <div class="info-item">
              <span class="label">课堂平台：</span>
              <span class="content">
                {{evaluateDetail.pointStatisticalOutbound && `${evaluateDetail.pointStatisticalOutbound.platformName === 'kitten' ? '源码编辑器' : '海龟编辑器'}`}}
              </span>
            </div>
            <div class="info-item">
              <span class="label">上课时间：</span>
              <span class="content">{{evaluateDetail.classroomDates | date('Y-m-d H:i')}} - {{evaluateDetail.classroomEndDates | date('H:i')}}</span>
            </div>
            <div class="info-item">
              <span class="label">课程名称：</span>
              <span class="content">{{evaluateDetail.pointStatisticalOutbound && evaluateDetail.pointStatisticalOutbound.pointName}}</span>
            </div>
            <div class="info-item">
              <span class="label">课程简介：</span>
              <span class="content" v-html="evaluateDetail.pointStatisticalOutbound && evaluateDetail.pointStatisticalOutbound.description"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="knowledge-wrap">
        <div class="knowledge-card">
          <span class="title">知识点标签</span>
          <ul class="knowledge-list" v-if="evaluateDetail.pointStatisticalOutbound">
            <li class="knowledge"
                v-for="(t, i) in evaluateDetail.pointStatisticalOutbound.knowledgeTagNames" :key="i">
              {{t.split(',')[t.split(',').length - 1]}}
            </li>
          </ul>
        </div>
      </div>
      <div class="divide">
        <span class="square"></span>
        <span class="desc">Data analysis</span>
        <span class="line"></span>
      </div>
      <div class="analysis-wrap">
        <h1>学情分析</h1>
        <div class="card-wrap">
          <div class="card evaluate-analysis">
            <ChartCard
              class="card-padding"
              :loading="loading">
              <div class="chartCardFooterItem" slot="footer">
              <span>
                作品数：
                <span>{{evaluateDetail.workStatisticalOutbound && evaluateDetail.workStatisticalOutbound.workCount}}</span>
              </span>
                <span>
                正确数：
                <span>{{evaluateDetail.workStatisticalOutbound && evaluateDetail.workStatisticalOutbound.workCorrectCount}}</span>
              </span>
                <span>
                错误数：
                <span>{{evaluateDetail.workStatisticalOutbound && evaluateDetail.workStatisticalOutbound.workErrorCount}}</span>
              </span>
              </div>
              <div slot="content" class="workCorrectRate">
                <div style="width: 50%">
                  <Gauge
                    :height="155"
                    label="作品正确率"
                    :percent="parseInt(evaluateDetail.workStatisticalOutbound && (evaluateDetail.workStatisticalOutbound.workCorrectRate || 0) * 100)"
                    smallStrokeColor="#E7F7FF"
                    bigStrokeColor="l (180) 0:#009AF4 1:#82E7F9"
                    labelColor="rgba(6,157,244,1)"
                    :shadowBlur="10"
                    :fontSize="32"
                    :lineHeight="45"
                  />
                </div>
                <div style="width: 50%">
                  <Gauge
                    :height="155"
                    label="作品错误率"
                    :percent="parseInt(evaluateDetail.workStatisticalOutbound && (evaluateDetail.workStatisticalOutbound.workErrorRate || 0) * 100)"
                    smallStrokeColor="#FFF5CD"
                    bigStrokeColor="l (180) 0:#FFB413 1:#FFE759"
                    labelColor="rgba(255,127,4,1)"
                    shadowColor="#FE9504"
                    :shadowBlur="6"
                    :fontSize="32"
                    :lineHeight="45"
                  />
                </div>

              </div>
            </ChartCard>
            <div class="green-line"></div>
            <ChartCard
              class="card-padding-top"
              title='平均完成时长'
              :loading="loading"
            >
            <!--<span slot="action">-->
              <!--<div slot="content">-->
                  <!--<div style="margin-bottom: 10px;">说明</div>-->
                  <!--<div>-->
                    <!--完成用时=学生从第一步开始互动到进入完成状态的时长-->
                  <!--</div>-->
                <!--</div>-->
                <!--<i class="el-icon-s-unfold" style="font-size: 14px"></i>-->
            <!--</span>-->
              <div slot="footer">
                <div class="chartCardFooter">
                  <div class="chartCardFooterItem">
                <span>
                  完成数：
                  <span class="info-desc">{{evaluateDetail.completeCount}}</span>
                </span>
                    <span>
                    未完成：
                  <span class="info-desc">{{evaluateDetail.uncompleteCount}}</span>
                  </span>
                  </div>
                  <div class="chartCardFooterItem">
                    <span>
                      高效王：
                      <span class="info-desc">{{evaluateDetail.maxEfficiency}}</span>
                    </span>
                    <span>
                      最专心：
                      <span class="info-desc">{{evaluateDetail.maxAttention}}</span>
                    </span>
                  </div>
                </div>
              </div>
              <div slot="content">
                <div class="avgTimes" >
                  <span>{{Math.round(evaluateDetail.avgTimes / 60 * 10) / 10}}</span>
                  <span>分钟</span>
                </div>
                <MiniProgress :percent="evaluateDetail.avgTimes * 100 / evaluateDetail.maxAttendanceTime"/>
              </div>
            </ChartCard>
          </div>
        </div>
        <div class="evaluate-detail">
          <p class="title">
            <span class="quote"></span>
            <span>课堂表现</span>
          </p>
          <div class="card-wrap">
            <div class="card class-analysis">
              <Ring
                :hasLegend="true"
                subTitle="平均课堂表现"
                :colors="['#05C18A','#96E935','#FDE302','#FF9300','#FF3B6D','#BB4BFF']"
                :shadows="['0px 2px 4px 0px rgba(0,200,130,0.3)','0px 2px 4px 0px rgba(255,225,151,1)','0px 2px 4px 0px rgba(253,115,81,0.41)',
                '0px 2px 4px 0px rgba(255,62,98,0.3)','0px 2px 4px 0px rgba(145,233,56,0.4)','0px 2px 4px 0px rgba(189,75,255,0.3)'
                ]"
                :total="evaluateDetail.avgClassroomPerformance"
                :sourceData="evaluateDetail.performanceStatistical && evaluateDetail.performanceStatistical"
                :height="270"
                :ringStyle="{ padding: '10px 0' }"
              />
              <div class="workCorrectRate">
                <div style="width: 33.333%">
                  <Gauge
                    :height="90"
                    label="优秀率"
                    :percent="parseInt((evaluateDetail.avgClassroomPerformanceGood || 0) * 100)"
                    smallStrokeColor="#F3F3F3"
                    bigStrokeColor="l (180) 0:#EDFF25 1:#01BE8B"
                    labelColor="#333"
                    :shadowBlur="10"
                    :fontSize="16"
                    :lineHeight="24"
                  />
                  <p class="desc">
                    课堂表现在<br/>
                    8分以上的比例
                  </p>
                </div>
                <div style="width: 33.333%">
                  <Gauge
                    :height="90"
                    label="一般率"
                    :percent="parseInt((evaluateDetail.avgClassroomPerformanceNormal || 0) * 100)"
                    smallStrokeColor="#F3F3F3"
                    bigStrokeColor="l (180) 0:#FEEF01 1:#FF9C00"
                    labelColor="#333"
                    :shadowBlur="6"
                    :fontSize="16"
                    :lineHeight="24"
                  />
                  <p class="desc">
                    课堂表现在<br/>
                    6-8分的比例
                  </p>
                </div>
                <div style="width: 33.333%">
                  <Gauge
                    :height="90"
                    label="低分率"
                    :percent="parseInt((evaluateDetail.avgClassroomPerformanceLow || 0) * 100)"
                    smallStrokeColor="#F3F3F3"
                    bigStrokeColor="l (180) 0:#955BFF 1:#F054FF"
                    labelColor="#333"
                    :shadowBlur="6"
                    :fontSize="16"
                    :lineHeight="24"
                  />
                  <p class="desc">
                    课堂表现在<br/>
                    6分以下的比例
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="evaluate-detail">
          <p class="title">
            <span class="quote"></span>
            <span>课程知识点掌握程度</span>
          </p>
          <div class="card-wrap" v-if="knowledgeData.length > 0">
            <div class="card knowledge-analysis">
              <div class="knowledge-wrap" v-for="(t, i) in knowledgeData" :key="i">
                <p class="knowledge">{{t.knowledge}}</p>
                <div class="knowledge-degree">
                  <bar :percent="t.degree"/>
                  <p class="degree">
                    {{t.degree}}<span>%</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="evaluate-detail" v-if="evaluateDetail.classroomImages && evaluateDetail.classroomImages.length">
          <p class="title">
            <span class="quote"></span>
            <span>课堂风采</span>
          </p>
          <div class="card-wrap">
            <div class="card class-style">
              <div class="style-container">
                <div class="img-wrap">
                  <img class="img" :src="t" v-for="(t, i) in evaluateDetail.classroomImages" :key="i"/>
                </div>
              </div>
              <p class="tip">滑动查看所有图片<i class="tip-icon"></i></p>
            </div>
          </div>
        </div>
        <div class="evaluate-detail" v-if="evaluateDetail.excellentStudentList && evaluateDetail.excellentStudentList.length">
          <p class="title">
            <span class="quote"></span>
            <span>优秀学生</span>
          </p>
          <div class="card-wrap">
            <div class="card class-style recommendStudentCard">
              <div class="style-container">
                 <div class="recommendStudents">
                  <div v-for="(student) in evaluateDetail.excellentStudentList" class="excellentStudent" :key="student.studentId" @click="toStudentEvalutateDetail(student.studentId)">
                    <i class="excellentStudentTag" />
                    <img
                      alt="头像"
                      :src="student.avatarUrl"
                    />
                    <span :title="student.studentName">{{student.studentName}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="divide" v-if="evaluateDetail.teacherComment || evaluateDetail.schoolTeacherComment">
        <span class="square"></span>
        <span class="desc">Teacher's evaluation</span>
        <span class="line"></span>
      </div>
      <div class="evaluate-wrap" v-if="evaluateDetail.teacherComment || evaluateDetail.schoolTeacherComment">
        <h1>课堂点评</h1>
        <div class="evaluate-detail" v-if="evaluateDetail.teacherComment">
          <p class="title">
            <span class="quote"></span>
            <span>猫老祖说 ——</span>
          </p>
          <p class="evaluate" v-html="evaluateDetail.teacherComment"></p>
        </div>
        <div class="divide-line" v-if="evaluateDetail.teacherComment && evaluateDetail.schoolTeacherComment">
          <div class="line"></div>
        </div>
        <div class="evaluate-detail" v-if="evaluateDetail.schoolTeacherComment">
          <p class="title">
            <span class="quote"></span>
            <span>课堂老师说 ——</span>
          </p>
          <p class="evaluate" v-html="evaluateDetail.schoolTeacherComment"></p>
        </div>
      </div>
    </div>
</template>

<script>
import { get } from '@/utils/ajax'
import TimelineChart from '@/components/TimelineChart'
import ChartCard from '@/components/ChartCard'
import Gauge from '@/components/Gauge'
import MiniProgress from '@/components/MiniProgress'
import Ring from '@/components/Ring'
import Pie from '@/components/Pie'
import Bar from '@/components/Bar'
import { WeChatShare } from '@/utils'
export default {
  components: {
    TimelineChart,
    ChartCard,
    Gauge,
    MiniProgress,
    Ring,
    Pie,
    Bar
  },
  data () {
    return {
      evaluateDetail: {},
      recentlyEvaluate: {},
      classEvaluate: [],
      performaceRate: [],
      knowledgeData: [],
      analysisArray: [
        { label: '平均课堂表现', value: 'avgClassroomPerformance' },
        { label: '完成度', value: 'completeDegree' },
        { label: '注意力', value: 'attention' },
        { label: '课堂效率', value: 'classroomEfficiency' }
      ],
      loading: true
    }
  },
  mounted () {
    this.getEvaluatedDetail()
  },
  methods: {
    replaceText (text) {
      return text.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>').replace(/\s/g, '&nbsp;')
    },
    wechatShare () {
      const shareInfo = {
        title: `${this.evaluateDetail.className}的${this.evaluateDetail.pointStatisticalOutbound && this.evaluateDetail.pointStatisticalOutbound.pointName}-课堂评价`, // 分享标题
        desc: '快来瞅瞅他们的课堂表现吧！', // 分享描述
        link: window.location.href, // 分享链接，该链接域名必须与当前企业的可信域名一致
        imgUrl: 'https://public-static-edu.codemao.cn/redcandlemobile/share/share_class.png'
      }
      WeChatShare(shareInfo)
    },
    toStudentEvalutateDetail(studentId) {
      const attendanceId = this.$route.query.attendanceId
      this.$router.push({ path: '/AIStudentEvaluate', query: { attendanceId, studentId } })
    },
    async getEvaluatedDetail () {
      const response = await get(`${CONFIG.ai_class}/patriarch/kps-study-class-evaluate?attendanceId=${this.$route.query.attendanceId}`)
      const res = await get(`${CONFIG.ai_class}/patriarch/kps-study-class-evaluate/recently?classId=${response.classId}`)
      this.recentlyEvaluate = res
      this.evaluateDetail = response

      this.recentlyEvaluate.forEach(item => {
        this.classEvaluate.push({
          ...item,
          x: Date.now() + 1000 * 60 * 60 * 24
          // item.classroomDates * 1000, // 给的数据是秒，不符合时间戳要求故改变下
        })
      })
      this.classEvaluate.push({
        attention: 41,
        avgClassroomPerformance: 11,
        classroomEfficiency: 30,
        completeDegree: 20,
        x: Date.now()
      })
      if (this.evaluateDetail && this.evaluateDetail.knowledgeDegree && this.evaluateDetail.knowledgeDegree.knowLedgeNames) {
        this.evaluateDetail.knowledgeDegree.knowLedgeNames.forEach((knowledgeName, index) => {
          this.knowledgeData.push({
            knowledge: knowledgeName.split(',')[knowledgeName.split(',').length - 1],
            degree: Math.round(Number(this.evaluateDetail.knowledgeDegree.degree.replace('%', '')) * 10) / 10
          })
        })
      }
      const performaceRate = [
        { levelId: 10, levelName: '课堂表现在8分以上的比例', studentNum: this.evaluateDetail.avgClassroomPerformanceGood, type: '优秀率' },
        { levelId: 8, levelName: '课堂表现在6-8分的比例', studentNum: this.evaluateDetail.avgClassroomPerformanceNormal, type: '一般率' },
        { levelId: 6, levelName: '课堂表现在6分以下的比例', studentNum: this.evaluateDetail.avgClassroomPerformanceLow, type: '不及格率' }
      ]
      this.evaluateDetail.performanceStatistical.map(item => {
        if (item.levelId >= 5) {
          performaceRate[0].studentNum += item.studentNum
        } else if (item.levelId < 5 && item.levelId >= 3) {
          performaceRate[1].studentNum += item.studentNum
        } else {
          performaceRate[2].studentNum += item.studentNum
        }
      })
      this.evaluateDetail.performanceStatistical.map(item => ({ ...item, studentNum: 10 }))
      this.performaceRate = performaceRate
      if (navigator.userAgent.toLocaleLowerCase().includes('micromessenger')) this.wechatShare()
      this.loading = false
      if (this.evaluateDetail.pointStatisticalOutbound && this.evaluateDetail.pointStatisticalOutbound.description) {
        this.evaluateDetail.pointStatisticalOutbound.description = this.replaceText(this.evaluateDetail.pointStatisticalOutbound.description)
      }
      if (this.evaluateDetail.teacherComment) {
        this.evaluateDetail.teacherComment = this.replaceText(this.evaluateDetail.teacherComment)
      }
      if (this.evaluateDetail.schoolTeacherComment) {
        this.evaluateDetail.schoolTeacherComment = this.replaceText(this.evaluateDetail.schoolTeacherComment)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.container
  width: 100%
  min-height: 100%
  background: #10C878 url('~@/assets/images/evaluate_bg.png') top center/contain no-repeat
  padding: 288px 0 32px
  position: relative
  h1
    font-size: 21px
    color: #ffffff
    margin-bottom: 17px
  .a-duan
    position: absolute
    top: 132px
    right: 0
    width: 160px
    height: 200px
    background: url('~@/assets/images/aduan.png') center/contain no-repeat
    z-index: 1
  .card-wrap
    width: 100%
    padding-left: 20px
    margin-bottom: 22.5px
    .card
      width: 100%
      background-color: #fff
      border-radius: 5px 0 0 30px
      position: relative
      &.classroom-info
        padding: 52.5px 20px 36.5px
      &.evaluate-analysis
        padding: 30px 0 32.5px
      &.class-analysis
        padding: 25px 20px 42.5px
      &.class-style
        padding: 40px 16px 55px
        .tip
          font-size: 14px
          color: #666
          text-align: center
          .tip-icon
            display: inline-block
            vertical-align: middle
            margin-left: 12px
            width: 18px
            height: 20px
            background: url('https://education.codemao.cn/27/public-edu/1/slide.svg') center / cover no-repeat
        .style-container
          width: 100%
          max-height: 640px
          overflow-y: scroll
          margin-bottom: 12px
          .img-wrap
            width: 100%
          .img
            width: 100%
            border-radius: 5px
      &.knowledge-analysis
        padding: 24px 18px 19px 20px
        .knowledge
          margin-bottom: 7px
          font-size: 12px
          color: #666
        .knowledge-degree
          display: flex
          align-items: center
          margin-bottom: 18px
          .degree
            margin: 0 0 0 6px
            font-size: 21px
            color: #333
            min-width: 2em
            text-align: right
            line-height: 1
            span
              font-size: 12px
      .title
        position: absolute
        top: 13px
        left: 20px
        color: #03301c
        font-weight: 500
        font-size: 21px
        line-height: 1
        margin: 0
      .title-arrow
        position: absolute
        top: 18px
        left: -6px
        width: 130px
        height: 26px
        background: url('~@/assets/images/evaluate_title_arrow.png') center/cover no-repeat
  .info
    padding: 25px 10px 23px
    background-color: rgba(16, 200, 120, .07)
    .info-item
      display: flex
      margin-bottom: 15px
      font-size: 14px
      color: #064127
      line-height: 25px
      .label
        flex 0 0 auto
        display: inline-block
        font-weight: 500
        min-width: 5em
        text-align: justify
      .content
        display: inline-block
        width: calc(100% - 5em)
        font-weight: 300
        word-wrap: break-word
        word-break: normal
  .knowledge-wrap
    width: 100%
    padding: 0 20px
    margin-bottom: 30px
    .knowledge-card
      width: 100%
      height: 100px
      background: url('~@/assets/images/knowledge_tag@2x.png') center / cover no-repeat
      position: relative
      padding-left: 24%
      .title
        position: absolute
        top: 50%
        left: 7%
        transform translateY(-50%)
        width: 45px
        font-size: 14px
        font-weight: 500
        text-align: center
        color: #03301c
  .knowledge-list
    display: flex
    width: 100%
    height: 100%
    padding: 0 17px 0 5px
    align-items: center
    justify-content: center
    .knowledge
      padding: 0 5px
      height: 22px
      background-color: #e7f9f1
      border-radius: 11px
      text-align: center
      line-height: 22px
      font-size: 12px
      color: #064127
      font-weight: 300
      margin-right: 8px
  .divide
    width: 100%
    padding: 0 10px 0 5px
    font-size: 14px
    opacity: .3
    display: flex
    align-items: center
    color: #fff
    margin-bottom: 8px
    .square
      display: inline-block
      width: 6.5px
      height: 6.5px
      background-color: #fff
      margin-right: 9px
    .desc
      margin-right: 19px
    .line
      height: 1px
      flex: 1
      background-color: #fff
  .evaluate-wrap, .analysis-wrap
    width: 100%
    padding: 0 30px 0 20px
  .evaluate-detail
    color: #fff
    .title
      display: flex
      .quote
        width: 36px
        height: 33px
        background: url('~@/assets/images/quote_icon.png') center / cover no-repeat
        margin-right: 10px
        display: inline-block
      span
        line-height: 1
        font-size: 18px
    .evaluate
      font-size: 14px
      line-height: 25px
      font-weight: 300
      margin: 0
      word-wrap: break-word
      word-break: normal
  .analysis-wrap
    padding: 0 0 0 20px
    .card-padding
      padding: 0 30px 32.5px 15px
    .card-padding-top
      padding: 21px 30px 0 15px
    .card-wrap
      padding: 0
    .green-line
      width: 100%
      height: 10px
      background-color: #10C878
  .divide-line
    margin: 28px 0 23px
    padding: 0 40px 0 20px
    .line
      height: 1px
      width: 100%
      background-color: #fff
      opacity: .2
.score
  padding: 25px 24px;
  display: flex;
  justify-content: space-between;
  .scoreItem
    &,div
      font-size:14px;
      font-weight:400;
      color:rgba(102,102,102,1);
      line-height:20px;
    .scoreNumber
      display: inline-block;
      width:46px;
      height:45px;
      text-align: center;
      font-size:32px;
      font-weight:400;
      color:rgba(51,51,51,1);
      line-height:45px;
.chartCardFooterItem
  display: flex;
  justify-content: space-between;
  span
    font-size:14px;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:20px;
    display: flex
    .info-desc
      color:rgba(51,51,51,1);
      font-weight: 500
      display: inline-block
      min-width: 4em
.workCorrectRate
  width: 100%
  display: flex;
  >div
    position: relative;
    flex: 1;
  .desc
    text-align: center
    color: #666;
    font-size: 12px;
    margin: 0
.avgTimes
  margin-top: 27px;
  span
    display: inline-block;
    font-size:48px;
    font-weight:400;
    color:rgba(68,68,68,1);
    line-height:60px;
  span:last-of-type
    font-size:12px;
    color:rgba(102,102,102,1);
    line-height:17px;
.performaceCardTitle
  font-size:18px;
  font-weight:400;
  color:rgba(68,68,68,1);
  line-height:25px;
  .dot
    display: inline-block;
    margin-right: 9px;
    width:8px;
    height:8px;
    border-radius: 4px;
    background:rgba(0,200,130,1);
.recommendStudentCard
  padding: 38.5px 16px 38px !important
.recommendStudents
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin: -10px -12px !important
  overflow: hidden
  .excellentStudent
    margin: 10px 12px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
    .excellentStudentTag
      display: inline-block;
      width: 10.5px;
      height: 14px;
      background:url('https://education.codemao.cn/27/public-edu/1/redboat/mlzEvaluateDetail/excelentStudent.png') no-repeat  center center;
      background-size: cover;
      z-index: 2;
      position: absolute;
      right: 0;
      top: 0;
    img
      width: 42px;
      height: 42px;
      border-radius: 31px;
      margin-bottom: 7.5px;
    span
      display: inline-block;
      text-align: center;
      width: 42px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 12px;
      color: #0B835F;
</style>
<style>
  html, body, #app {
    overflow: scroll
  }
</style>
